import React from 'react';
import styles from '../BotResponse.module.scss';
import Carousel from 'component/molecules/carousel/Carousel';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import VoiceTag from 'component/atom/voice-tag/VoiceTag';
import GenerateForm from './components/form/GenerateForms';
import TypingMessage from './components/typying-message/TypingMessage';
import { transformChatData } from 'component/organism/chat-console/factory/transformData';
import downloadUrlFile from 'helpers/downloadUrlFile';

const renderStepContent = ({
  step,
  sideBar_PrimaryColor,
  isWorkFlow,
  chatId,
  botId,
  setGuestChat,
  setCapture,
  setSuggestedQuestions,
  isExpanded,
  restartForm,
  guestChat,
  isConversation,
  triggerNewConversation,
}) => {
  switch (step?.type) {
    case 'Message':
      return (
        <div
          className={styles['request-text']}
          dir='auto'
          style={{ unicodeBidi: 'isolate' }}
        >
          <TypingMessage text={step.value} />
        </div>
      );

    case 'Image':
      return (
        <div className={styles['image-response']}>
          <img src={step.value} alt={step.value} />
        </div>
      );

    case 'Video':
      return (
        <div className={styles['video-response']}>
          <video controls>
            <source src={step.value} type='video/mp4' />
            Your browser does not support the video tag.
          </video>
        </div>
      );

    case 'Carousel':
      return (
        <div className={styles['carousel-response']}>
          {step?.value?.details?.length > 0 ? (
            <Carousel data={step.value.details} />
          ) : null}
        </div>
      );

    case 'Document':
      return (
        <div className={styles['file-response']}>
          <SvgWithBranding
            type='download'
            className={`${styles.svg} ${styles['download-svg']}`}
            color={sideBar_PrimaryColor}
            onClick={() => downloadUrlFile(step.value, step.name)}
          />
          <p>{step.name ?? 'Document'}</p>
          <SvgWithBranding
            type='file'
            className={styles.svg}
            color={sideBar_PrimaryColor}
          />
        </div>
      );

    case 'Voice':
      return (
        <div className={styles['voice-response']}>
          <VoiceTag />
        </div>
      );
    // case 'Question':
    //   return (
    //     // <TypingQuestions
    //     //   step={step}
    //     //   isRequesting={isRequesting}
    //     //   formik={formik}
    //     // />
    //     <div className={styles['questions-response']}>
    //       {Array.isArray(step?.value)
    //         ? step?.value?.map((val, index) => (
    //             <div
    //               key={val.id || `question-${index}`}
    //               className={styles['question']}
    //               onClick={() => {
    //                 if (isRequesting) return;
    //                 formik.setFieldValue('Question', val.questionText);

    //                 formik.setFieldValue('sourceHandle', val.sourceHandle);

    //                 formik.handleSubmit();
    //               }}
    //             >
    //               <p>{val.questionText}</p>
    //               <SvgWithBranding type="arrow" />
    //             </div>
    //           ))
    //         : step?.value}
    //     </div>
    //   );
    case 'Form':
      return (
        <div className={styles['form-response']}>
          <GenerateForm
            step={step}
            isWorkFlow={isWorkFlow}
            chatId={chatId}
            botId={botId}
            onChatUpdate={(newChatData) => {
              setGuestChat((prev) => ({
                ...prev,
                ...newChatData,
                messages: [
                  ...prev.messages,
                  ...transformChatData(newChatData).messages,
                ],
              }));
            }}
            setSuggestedQuestions={setSuggestedQuestions}
            setCapture={setCapture}
            isExpanded={isExpanded}
            restartForm={restartForm}
            guestChat={guestChat}
            isConversation={isConversation}
            triggerNewConversation={triggerNewConversation}
          />
        </div>
      );
    default:
      return null;
  }
};

export default renderStepContent;
